exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon-green[data-v-a62d1c4e] {\n  color: rgb(109, 194, 135);\n}\n", ""]);

// exports
